// web/src/lib/brand.ts — YourProject.ai brand + customer-facing vocabulary.
//   Site = project · Request = run/pipeline · Workspace = org.
export const BRAND = {
  name: 'YourProject.ai',
  shortName: 'YourProject',
  tagline: 'Ship changes to your sites — just ask.',
} as const;

export const VOCAB = {
  site: 'Site', sites: 'Sites',
  request: 'Request', requests: 'Requests',
  workspace: 'Workspace',
} as const;

// SCHOOL_URL removed 2026-08-18 — the School product is parked and all customer-facing
// links were stripped (marketing/plan/08). Restore from git history if it ever returns.
